module.exports = __webpack_public_path__ + "static/media/4_of_clubs.037d8c23.svg";